<div class="vzc-set-password">
  <h1 class="vzc-set-password__heading" i18n="@@S_ACCOUNT_ACTIVATION_SET_PASSWORD_HEADING">Set your password</h1>

  <ng-container *ngIf="!username; then usernameRequired; else usernameProvided"></ng-container>

  <form [formGroup]="form" autocomplete="off">
    <app-email-address *ngIf="!username" [email]="email"></app-email-address>
    <app-password [password]="password" [passwordConfirm]="passwordConfirm"></app-password>

    <app-spinner-button
      i18n-label="@@S_CAP_ACCOUNT_ACTIVATION_SET_PASSWORD"
      label="SET PASSWORD"
      [isSpinning]="(setPasswordRequestStatus$ | async) === apiRequestStatus.Request"
      [isDisabled]="form.invalid || (setPasswordRequestStatus$ | async) === apiRequestStatus.Request"
      (clickFunction)="initialiseRequest()"
    ></app-spinner-button>
  </form>

  <app-warning-banner
    *ngIf="isRequestFailure$ | async"
    i18n-errorMessage="@@E_ACCOUNT_ACTIVATION_SET_PASSWORD_ERROR_MESSAGE"
    errorMessage="We could not set your password. Please try again."
  ></app-warning-banner>
</div>

<ng-template #usernameRequired>
  <p class="vzc-set-password__subheading" i18n="@@S_ACCOUNT_ACTIVATION_SET_PASSWORD_SUBHEADING">
    Enter the email address that was used to create your account, and set your password.
  </p>
</ng-template>
<ng-template #usernameProvided>
  <p class="vzc-set-password__subheading" i18n="@@S_ACCOUNT_ACTIVATION_SET_PASSWORD_SUBHEADING_ENTER_PASSWORD">
    Enter a password for your account.
  </p>
</ng-template>
